// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-expired-overlay {
  --session-icon-fill: rgba(15, 76, 129, 0.08);
  --session-icon-stroke: #0f4c81;
  --session-accent: #0f4c81;
  --session-text: #1c2430;
  --session-muted: #5c6670;
  --session-surface: #ffffff;
  --session-panel: #f4f7fa;
  --session-border: #e2e8ef;
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: radial-gradient(ellipse 80% 60% at 50% 40%, rgba(15, 76, 129, 0.12), transparent 70%), rgba(12, 22, 36, 0.55);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.28s ease, visibility 0.28s ease;
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
}
.session-expired-overlay.active {
  opacity: 1;
  visibility: visible;
}

.session-expired-container {
  position: relative;
  width: min(100%, 26rem);
  background: var(--session-surface);
  border-radius: 12px;
  border: 1px solid var(--session-border);
  box-shadow: 0 1px 2px rgba(12, 22, 36, 0.06), 0 18px 40px rgba(12, 22, 36, 0.18);
  overflow: hidden;
  text-align: center;
}

.session-expired-accent {
  height: 4px;
  width: 100%;
  background: linear-gradient(90deg, var(--session-accent) 0%, color-mix(in srgb, var(--session-accent) 55%, #5b9bd5) 100%);
}

.session-expired-icon {
  display: flex;
  justify-content: center;
  padding: 1.75rem 1.5rem 0.5rem;
}
.session-expired-icon svg {
  display: block;
}

.session-expired-header {
  padding: 0.35rem 1.75rem 0;
}

.session-expired-title {
  margin: 0;
  font-family: "Montserrat", "OpenSans-Regular", system-ui, sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--session-text);
  line-height: 1.25;
}

.session-expired-subtitle {
  margin: 0.4rem 0 0;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--session-accent);
  letter-spacing: 0.01em;
}

.session-expired-body {
  padding: 1rem 1.75rem 0.25rem;
}

.session-expired-message {
  margin: 0;
  padding: 0.85rem 1rem;
  background: var(--session-panel);
  border: 1px solid var(--session-border);
  border-radius: 8px;
  font-size: 0.95rem;
  line-height: 1.55;
  color: var(--session-muted);
}

.session-expired-footer {
  padding: 1.35rem 1.75rem 1.75rem;
}

.session-expired-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  min-height: 2.75rem;
  padding: 0.7rem 1.25rem;
  border: none;
  border-radius: 8px;
  background: var(--undp-jtf-primary-color, var(--session-accent));
  color: #fff;
  font-family: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  box-shadow: 0 2px 8px rgba(15, 76, 129, 0.25);
}
.session-expired-btn svg {
  flex-shrink: 0;
}
.session-expired-btn:hover {
  opacity: 0.94;
  box-shadow: 0 4px 14px rgba(15, 76, 129, 0.3);
}
.session-expired-btn:active {
  transform: translateY(1px);
  opacity: 0.9;
}
.session-expired-btn:focus-visible {
  outline: 2px solid var(--session-accent);
  outline-offset: 3px;
}

@media (max-width: 480px) {
  .session-expired-overlay {
    padding: 1rem;
    align-items: flex-end;
  }
  .session-expired-container {
    width: 100%;
    border-radius: 12px 12px 8px 8px;
  }
  .session-expired-title {
    font-size: 1.2rem;
  }
}
/* Fallback if color-mix unsupported */
@supports not (background: color-mix(in srgb, #000 50%, #fff)) {
  .session-expired-accent {
    background: var(--session-accent);
  }
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/session-expired/session-expired-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,4CAAA;EACA,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,wBAAA;EACA,yBAAA;EAEA,eAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yHACE;EAEF,UAAA;EACA,kBAAA;EACA,qDAAA;EACA,0BAAA;EACA,kCAAA;AAFF;AAIE;EACE,UAAA;EACA,mBAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,uBAAA;EACA,kCAAA;EACA,mBAAA;EACA,uCAAA;EACA,gFACE;EAEF,gBAAA;EACA,kBAAA;AALF;;AAQA;EACE,WAAA;EACA,WAAA;EACA,yHAAA;AALF;;AAYA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;AATF;AAWE;EACE,cAAA;AATJ;;AAaA;EACE,0BAAA;AAVF;;AAaA;EACE,SAAA;EACA,oEAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,iBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,sBAAA;AAVF;;AAaA;EACE,6BAAA;AAVF;;AAaA;EACE,SAAA;EACA,qBAAA;EACA,gCAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,2BAAA;AAVF;;AAaA;EACE,gCAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,gEAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,2EAAA;EACA,6CAAA;AAVF;AAYE;EACE,cAAA;AAVJ;AAaE;EACE,aAAA;EACA,6CAAA;AAXJ;AAcE;EACE,0BAAA;EACA,YAAA;AAZJ;AAeE;EACE,wCAAA;EACA,mBAAA;AAbJ;;AAiBA;EACE;IACE,aAAA;IACA,qBAAA;EAdF;EAiBA;IACE,WAAA;IACA,gCAAA;EAfF;EAkBA;IACE,iBAAA;EAhBF;AACF;AAmBA,sCAAA;AACA;EACE;IACE,iCAAA;EAjBF;AACF","sourcesContent":[".session-expired-overlay {\n  --session-icon-fill: rgba(15, 76, 129, 0.08);\n  --session-icon-stroke: #0f4c81;\n  --session-accent: #0f4c81;\n  --session-text: #1c2430;\n  --session-muted: #5c6670;\n  --session-surface: #ffffff;\n  --session-panel: #f4f7fa;\n  --session-border: #e2e8ef;\n\n  position: fixed;\n  inset: 0;\n  z-index: 10050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n  background:\n    radial-gradient(ellipse 80% 60% at 50% 40%, rgba(15, 76, 129, 0.12), transparent 70%),\n    rgba(12, 22, 36, 0.55);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.28s ease, visibility 0.28s ease;\n  backdrop-filter: blur(3px);\n  -webkit-backdrop-filter: blur(3px);\n\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.session-expired-container {\n  position: relative;\n  width: min(100%, 26rem);\n  background: var(--session-surface);\n  border-radius: 12px;\n  border: 1px solid var(--session-border);\n  box-shadow:\n    0 1px 2px rgba(12, 22, 36, 0.06),\n    0 18px 40px rgba(12, 22, 36, 0.18);\n  overflow: hidden;\n  text-align: center;\n}\n\n.session-expired-accent {\n  height: 4px;\n  width: 100%;\n  background: linear-gradient(\n    90deg,\n    var(--session-accent) 0%,\n    color-mix(in srgb, var(--session-accent) 55%, #5b9bd5) 100%\n  );\n}\n\n.session-expired-icon {\n  display: flex;\n  justify-content: center;\n  padding: 1.75rem 1.5rem 0.5rem;\n\n  svg {\n    display: block;\n  }\n}\n\n.session-expired-header {\n  padding: 0.35rem 1.75rem 0;\n}\n\n.session-expired-title {\n  margin: 0;\n  font-family: 'Montserrat', 'OpenSans-Regular', system-ui, sans-serif;\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--session-text);\n  line-height: 1.25;\n}\n\n.session-expired-subtitle {\n  margin: 0.4rem 0 0;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--session-accent);\n  letter-spacing: 0.01em;\n}\n\n.session-expired-body {\n  padding: 1rem 1.75rem 0.25rem;\n}\n\n.session-expired-message {\n  margin: 0;\n  padding: 0.85rem 1rem;\n  background: var(--session-panel);\n  border: 1px solid var(--session-border);\n  border-radius: 8px;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  color: var(--session-muted);\n}\n\n.session-expired-footer {\n  padding: 1.35rem 1.75rem 1.75rem;\n}\n\n.session-expired-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n  min-height: 2.75rem;\n  padding: 0.7rem 1.25rem;\n  border: none;\n  border-radius: 8px;\n  background: var(--undp-jtf-primary-color, var(--session-accent));\n  color: #fff;\n  font-family: inherit;\n  font-size: 0.95rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;\n  box-shadow: 0 2px 8px rgba(15, 76, 129, 0.25);\n\n  svg {\n    flex-shrink: 0;\n  }\n\n  &:hover {\n    opacity: 0.94;\n    box-shadow: 0 4px 14px rgba(15, 76, 129, 0.3);\n  }\n\n  &:active {\n    transform: translateY(1px);\n    opacity: 0.9;\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--session-accent);\n    outline-offset: 3px;\n  }\n}\n\n@media (max-width: 480px) {\n  .session-expired-overlay {\n    padding: 1rem;\n    align-items: flex-end;\n  }\n\n  .session-expired-container {\n    width: 100%;\n    border-radius: 12px 12px 8px 8px;\n  }\n\n  .session-expired-title {\n    font-size: 1.2rem;\n  }\n}\n\n/* Fallback if color-mix unsupported */\n@supports not (background: color-mix(in srgb, #000 50%, #fff)) {\n  .session-expired-accent {\n    background: var(--session-accent);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
